import React, {
    Component,
    Fragment,
} from 'react'
import Button from '../../shared/sn-button'
import Loader from '../../shared/loader'
import SnIcon from '../../shared/sn-icon'
import {
    i18n,
    withRouter,
} from '../../../../validator'
import { redirectToConversation as redirectToConversationHelper } from '../../../../components/messenger/helper'
import classNames from 'classnames'

const chatCircle = '/images/profile/chat-circle.svg'

@i18n()
@withRouter()
export default class MessengerButton extends Component {
    state = {
        busyMessage: false,
    }

    /**
     * Redirect to conversation with user
     *
     * @param {Object} user
     * @return {Promise<void>}
     */
    redirectToConversation = user => {
        if (this.state.busyMessage) {
            return new Promise(resolve => resolve())
        }

        this.setState({ busyMessage: true })

        return redirectToConversationHelper(user, this.props.history)
            .then(() => this.setState({ busyMessage: false }))
    }

    /**
     * Render
     *
     * @return {*}
     */
    render() {
        const { busyMessage } = this.state

        const {
            t,
            user,
            onClick,
            squareLook,
        } = this.props

        return (
            <Button
                onClick={onClick ? onClick : () => this.redirectToConversation(user)}
                className={classNames({
                    'u-circle': !squareLook,
                    'u-square d-flex flex-row align-items-center h-100': squareLook,
                })}
            >
                {busyMessage && <Loader height={20} />}
                {!busyMessage &&
                    <Fragment>
                        {squareLook &&
                            <img
                                src={chatCircle}
                                className="mr-1"
                            />
                        }
                        {!squareLook &&
                            <SnIcon
                                isHoverable={true}
                                className="sn-lg sn-message"
                                notHoverClassName="sn-message-circle-empty"
                                hoverClassName="sn-message-circle-fill"
                            />
                        }
                        {t('write')}
                    </Fragment>
                }
            </Button>
        )
    }
}
